/**
 *Created by jmmartinez on 05/08/2021

 * 19/06/2024 v.1.11 En changeValor, añadida la condición editorExternoColumn.editorExterno &&
 */

import React from 'react'
import PropTypes from 'prop-types';
import {Radio, RadioGroup} from "@blueprintjs/core";

class EditorLista extends React.Component {

    constructor(props) {
        super(props)

        let campo= props.editorExternoColumn.campo;
        let valorInicial= props.editorExternoObjeto[campo] ? Number(props.editorExternoObjeto[campo]) : 0;

        this.state = {
            valor: valorInicial,
            campo: campo,
            valorOriginal: valorInicial,
        }

    }


    changeValor= (newValor) => {
        const {valorOriginal} = this.state;
        const {onCloseEditor, gridRDG, editorExternoColumn, editorExternoObjeto} = this.props;

        console.log("EditorLista - changeValor");
        console.log("editorExternoColumn: ", editorExternoColumn.editorExterno);
        if (editorExternoColumn.editorExterno && editorExternoColumn.editorExterno.onCambioPermitido) {
            let oResultadoCambioPermitido= editorExternoColumn.editorExterno.onCambioPermitido(valorOriginal, newValor, editorExternoObjeto);
            console.log("oResultadoCambioPermitido: ", oResultadoCambioPermitido);
            if (!oResultadoCambioPermitido.exito) {
                alert (oResultadoCambioPermitido.mensaje);
                this.setState({valor: Number(valorOriginal)});
            } else {
                this.setState({valor: Number(newValor)}, () => {
                        onCloseEditor && onCloseEditor(newValor)
                    }
                );
            }
        }
        else{
            this.setState({valor: Number(newValor)}, () => {
                    onCloseEditor && onCloseEditor(newValor)
                }
            );
        }
    }

    render() {
        const {valor} = this.state;
        const {editorExternoColumn} = this.props;
        let titulo= "Seleccione una opción de " + editorExternoColumn.titulo.toUpperCase();
        return (
            <RadioGroup
                label={titulo}
                onChange={(event) => this.changeValor(event.target.value)}
                selectedValue={valor}
            >
                {
                    editorExternoColumn.valores.map ( (valor, index) => {
                        return <Radio key={index} label={valor.nombre} value={valor.codigo} />
                    })
                }
            </RadioGroup>
        )

    }

}


EditorLista.propTypes = {
    gridRDG: PropTypes.object,
    editorExternoColumn: PropTypes.object,
    editorExternoObjeto: PropTypes.object,
    onCloseEditor: PropTypes.func,
}

export default EditorLista;